





































import { Vue, Component } from "vue-property-decorator";
import { authService } from "../_services";
import * as auth from "../_store/auth.module";

@Component
export default class ValidationPage extends Vue {
  private token: string | null;
  private email: string | null;

  constructor() {
    super();
    this.token = "";
    this.email = "";
  }

  created() {
    var strArray: string[] = [];
    var urlArray: string[] = [];
    var urlString: string = window.location.href;
    urlArray = urlString.split("?");
    // https://valtis.infosys.it/#/validationPage?username=GRBDVD95R17F351N
    urlString = " https://valtis.infosys.it/#/validationPage?" + urlArray[1];
    strArray  = urlArray[1].split('=')
    this.token = strArray[1];
    // const url = new URL(urlString);
    // var searchParams = new URLSearchParams(url.search);
    // this.username = url.searchParams.get("username");
    // this.email = url.searchParams.get("email");
    if (this.token !== null) {
      auth.dispatchValidation(this["$store"], this.token);
    }

    // if(this.email !== null){
    //   strArray = this.email.split('@');
    //   this.email = strArray[0] + '@' + strArray[1];
    // }

  }
}
